<script lang="ts" setup>
import type { TpgSelectEvent } from '@tpg/grammar-web';
import type { Slot } from 'vue';

export interface GrammarFooterProps {
  emphasis?: 'default' | 'context-active' | 'no-background';
  slotOverride?: boolean;
  doubleSlot?: boolean;
}

interface GrammarFooterSlots {
  'left-button'?: Slot;
  'right-button'?: Slot;
  'top-button'?: Slot;
  'menu'?: Slot;
  'override-top-content'?: Slot;
  'override-bottom-content'?: Slot;
}

const props = withDefaults(defineProps<GrammarFooterProps>(), {
  emphasis: 'default',
  slotOverride: false,
  doubleSlot: false,
});

const emit = defineEmits<{
  select: [event: TpgSelectEvent];
}>();

const slots = defineSlots<GrammarFooterSlots>();

function onSelect(event: TpgSelectEvent) {
  emit('select', event);
}
</script>

<template>
  <tpg-footer v-bind="props" @tpg-select="onSelect">
    <div v-if="slots['left-button']" slot="left-button">
      <slot name="left-button" />
    </div>

    <div v-if="slots['right-button']" slot="right-button">
      <slot name="right-button" />
    </div>

    <div v-if="slots['top-button']" slot="top-button">
      <slot name="top-button" />
    </div>

    <div v-if="slots.menu" slot="menu">
      <slot name="menu" />
    </div>

    <div v-if="slots['override-top-content']" slot="override-top-content">
      <slot name="override-top-content" />
    </div>

    <div
      v-if="slots['override-bottom-content']"
      slot="override-bottom-content"
      class="min-w-0"
    >
      <slot name="override-bottom-content" />
    </div>
  </tpg-footer>
</template>
